import { Avatar, Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { shiftConflictIsDate } from 'modules/shift_management/lib/shiftConflictIsDate'
import type { RestDay } from 'modules/shift_management/lib/types'

interface Props {
  date: moment.Moment
  restDay: RestDay
}

const RestDayItem = ({ date, restDay }: Props) => {
  const [{ shiftsConflicts }] = useSchedule()

  const hasConflictWithRestDay = (date: moment.Moment, restDay: RestDay): boolean => {
    return shiftsConflicts.shift_conflicts.some(
      (sc) => shiftConflictIsDate(sc, date) && sc.hasConflictWithRestDay(restDay)
    )
  }

  const hasConflict = hasConflictWithRestDay(date, restDay)

  return (
    <Box key={restDay.id} gap="s12" flexDirection="column" alignItems="flexStart">
      <Box flexDirection="row" alignItems="center" gap="s12">
        <Avatar
          size="s24"
          url={buildUrl(restDay.employeeAvatar)}
          label={restDay.employeeFullName}
        />
        <Text.Normal>{restDay.employeeFullName}</Text.Normal>
      </Box>
      {hasConflict && (
        <Tag type="radical">{i18n.t('shift_management.sidepanel.shift_conflict')}</Tag>
      )}
    </Box>
  )
}

export default observer(RestDayItem)
